import { makeStyles } from 'tss-react/mui';

import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';

export const useInfiniteScrollContainerStyles = makeStyles()(() => ({
  infiniteScrollContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    ...VERTICAL_SCROLL_STYLE,
  },
  spinnerContainer: {
    width: '700px',
    height: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  itemWrapper: {
    width: '100%',
  },
}));
